/**
 * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating
 * @author Alex_Crack
 * @version v0.2.0
 * @link https://github.com/alexcrack/angular-ui-notification
 * @license MIT
 */
 angular.module('ui-notification',[]);

 angular.module('ui-notification').provider('Notification', function() {
 
     this.options = {
         delay: 5000,
         startTop: 10,
         startRight: 10,
         verticalSpacing: 10,
         horizontalSpacing: 10,
         positionX: 'center',
         positionY: 'top',
         replaceMessage: false,
         templateUrl: 'angular-ui-notification.html',
         onClose: undefined,
         closeOnClick: true,
         maxCount: 0 // 0 - Infinite
     };
 
     this.setOptions = function(options) {
         if (!angular.isObject(options)) throw new Error("Options should be an object!");
         this.options = angular.extend({}, this.options, options);
     };
 
     this.$get = ["$timeout", "$http", "$compile", "$templateCache", "$rootScope", "$injector", "$sce", "$q", "$window", function($timeout, $http, $compile, $templateCache, $rootScope, $injector, $sce, $q, $window) {
         var options = this.options;
 
         var startTop = options.startTop;
         var startRight = options.startRight;
         var verticalSpacing = options.verticalSpacing;
         var horizontalSpacing = options.horizontalSpacing;
         var delay = options.delay;
 
         var messageElements = [];
         var isResizeBound = false;
 
         var notify = function(args, t){
             var deferred = $q.defer();
 
             if (typeof args !== 'object') {
                 args = {message:args};
             }
 
             args.scope = args.scope ? args.scope : $rootScope;
             args.template = args.templateUrl ? args.templateUrl : options.templateUrl;
             args.delay = !angular.isUndefined(args.delay) ? args.delay : delay;
             args.type = t || options.type ||  '';
             args.positionY = args.positionY ? args.positionY : options.positionY;
             args.positionX = args.positionX ? args.positionX : options.positionX;
             args.replaceMessage = args.replaceMessage ? args.replaceMessage : options.replaceMessage;
             args.onClose = args.onClose ? args.onClose : options.onClose;
             args.closeOnClick = (args.closeOnClick !== null && args.closeOnClick !== undefined) ? args.closeOnClick : options.closeOnClick;
             toastr.options = {
                 "closeButton": false,
                 "debug": false,
                 "newestOnTop": false,
                 "progressBar": false,
                 "positionClass": "toast-top-right",
                 "preventDuplicates": true,
                 "onclick": null,
                 "showDuration": "300",
                 "hideDuration": "1000",
                 "timeOut": args.delay,
                 "extendedTimeOut": "1000",
                 "showEasing": "swing",
                 "hideEasing": "linear",
                 "showMethod": "fadeIn",
                 "hideMethod": "fadeOut"
               }
             toastr[args.type](args.message);	
             /*Swal.fire({
                 position: 'top-end',
                 type: args.type,
                 showConfirmButton: false,
                 html: args.message,
                 timer: args.delay,
             })*/
             return deferred.promise;
         };
 
         notify.primary = function(args) {
             return this(args, 'primary');
         };
         notify.error = function(args) {
             return this(args, 'error');
         };
         notify.success = function(args) {
             return this(args, 'success');
         };
         notify.info = function(args) {
             return this(args, 'info');
         };
         notify.warning = function(args) {
             
             return this(args, 'warning');
         };
 
         notify.clearAll = function() {
             angular.forEach(messageElements, function(element) {
                 element.addClass('killed');
                 element.parentNode.removeChild(element);
             });
         };
 
         return notify;
     }];
 });
 
 angular.module("ui-notification").run(["$templateCache", function($templateCache) {$templateCache.put("angular-ui-notification.html","<div class=\"ui-notification\"><h3 ng-show=\"title\" ng-bind-html=\"title\"></h3><div class=\"message\" ng-bind-html=\"message\"></div></div>");}]);